import { Action, Dispatch } from 'redux'
import { setPasswordErrorAction } from 'reducks/error/actions'

const isValidPassword = (password: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const regex = /^[a-zA-Z0-9]{6}.*$/
    const ret = regex.test(password)
    if (ret) {
      dispatch(setPasswordErrorAction(''))
    } else {
      dispatch(setPasswordErrorAction('パスワードは6文字以上の英数字で入力してください。'))
    }
  }
}

export default isValidPassword
